export type CampaignAd = {
  id: number
  name: string
  clicks: number
  views: number
  share: number
  ctr: number
  is_running: boolean
  type: string
}

export const emptyAd = (): CampaignAd => ({
  id: 0,
  name: '',
  clicks: 0,
  views: 0,
  share: 0,
  ctr: 0,
  is_running: false,
  type: '',
})

export const campaignAdFromServer = (x?: any): CampaignAd =>
  x
    ? {
        id: x.id,
        name: x.name,
        clicks: x.clicks,
        views: x.views,
        share: x.share,
        ctr: x.ctr,
        is_running: x.is_running,
        type: x.type,
      }
    : emptyAd()

export const getCampaignAdsQuery = meta => ({
  limit: meta.rowsPerPage,
  offset: meta.page * meta.rowsPerPage,
  sort_by: meta.sortBy || undefined,
  sort_order: meta.sortOrder || undefined,
})
